import { render, staticRenderFns } from "./ModalChat.vue?vue&type=template&id=077d1bef&scoped=true&lang=pug&"
import script from "./ModalChat.vue?vue&type=script&lang=ts&"
export * from "./ModalChat.vue?vue&type=script&lang=ts&"
import style0 from "./ModalChat.vue?vue&type=style&index=0&id=077d1bef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d1bef",
  null
  
)

export default component.exports